import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { tupleNum } from '../_utils/type';
import Base from './base';
import devWarning from '../_utils/devwarning';
export var TitleLevels = tupleNum(1, 2, 3);
var Title = function Title(props) {
  var _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    restProps = __rest(props, ["level"]);
  var component;
  if (TitleLevels.indexOf(level) !== -1) {
    component = "h".concat(level);
  } else {
    devWarning(true, 'typography', "cannot found level '".concat(level, "'"));
    component = 'h1';
  }
  return /*#__PURE__*/React.createElement(Base, _extends({}, restProps, {
    component: component
  }));
};
export default Title;